export class Contract {
    contractid: number = null;
    contractdesc: string = null;
    contractstate: number = null;
    contracttype: number = null;
    contractcustomer: number = null;
    contractnote: string = null;
    contractnumber: string = null;
    contractitem: ContractItem[];
    contractcreation: string = null;
    contractcreator: string = null;
    concurrencystamp: string = null;
}

export class ContractItem {
    itemid: number = null;
    itemname: string = null;
    itemfaktdate: string = null;
    itembuildindate: string = null;
    itemcontractid: number = null;
    itemcount: number = null;
    itemproduct: number = null;
    itemdesc: string = null;
    iteminfo: string = null;
    itemcanceldate: string = null;
    itemsetupcost: number = null;
    itempurchasecost: number = null;
    itemrentalcost: number = null;
    itemlocation: number = null;
    itemposition: number = null;
    contract: Contract;
}

export class ContractStatus {
    contractstateid: number;
    contractstatename: string;
    contractstatedesc: string;
}

export class ContractType {
    contracttypeid: number;
    contracttypename: string;
    contracttypedesc: string;
}
